import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { mergeMap } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';
import { User } from '../types/users.types';

@Injectable()
export class UsersService {
  private readonly apiHost: string;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.apiHost = config.params.apiHost as string;
  }

  public getUsers(): Observable<User[] | Error> {
    const url = `${this.apiHost}/v1/deals/fixed-income/municipal/users`;

    return this.http.get(url, { observe: 'response' }).pipe(
      mergeMap((response: HttpResponse<any>) => {
        const data = response.status === 200 && response.body;

        return data ? of(data.users) : throwError(Error('Cannot load Users'));
      })
    );
  }
}
